"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _NavigationListItem = _interopRequireDefault(require("./NavigationListItem"));

var _Layout = require("../../Layout");

var NavigationList = function NavigationList(_ref) {
  var links = _ref.links,
      place = _ref.place,
      rest = _objectWithoutProperties(_ref, ["links", "place"]);

  var NavContainer = rest.isLargeNav ? _Layout.Container : 'div';

  var _ref2 = (0, _emotionTheming.useTheme)(),
      navigation = _ref2.navigation;

  return /*#__PURE__*/_react.default.createElement(NavContainer, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, null, links.map(function (link, key) {
    return /*#__PURE__*/_react.default.createElement(_Layout.Column // eslint-disable-next-line react/no-array-index-key
    , {
      key: "".concat(link.label, "_").concat(key),
      width: navigation.navListGrid
    }, /*#__PURE__*/_react.default.createElement(_NavigationListItem.default, Object.assign({
      link: link,
      place: place
    }, rest)));
  })));
};

NavigationList.propTypes = {
  links: _propTypes.default.arrayOf(Object).isRequired,
  place: _propTypes.default.oneOf(['header', 'footer', 'legacyHeader'])
};
NavigationList.defaultProps = {
  place: 'footer'
};
var _default = NavigationList;
exports.default = _default;